module.exports = __webpack_public_path__ + "images/emoji/mouse2.97cc5ba1ba8673622096.png";